const BUSINESS_SUFFIXES = ['llc', 'inc', 'corp', 'co', 'company', 'consulting', 'services'];

// Garbage / non-employer text patterns. Match → skip the API call entirely (no Google,
// no tracking row). The backend used to do this; it now trusts the frontend to filter.
const SKIP_KEYWORDS = [/\bn\/?a\b/, /\bretired\b/, /\bunemployed\b/, /\bstudent\b/];

const SELF_KEYWORDS = [
  /\bself[-\s]?employed\b/,
  /\bfreelancer?\b/,
  /\bindependent\s+contractor\b/,
  /\bself\b/,
];

const normalize = (value: string): string =>
  value
    .toLowerCase()
    .replace(/[‘’ʼ‛′`]/g, "'")
    .replace(/[.,]/g, '')
    .replace(/\s+/g, ' ')
    .trim();

export const shouldSkipEmployerLookup = (employerName: string): boolean => {
  const raw = (employerName ?? '').trim();
  if (raw.length === 0) return true;
  if (raw.length === 1) return true;
  if (/^\d+$/.test(raw)) return true;

  const value = normalize(raw);
  return SKIP_KEYWORDS.some((p) => p.test(value));
};

// Heuristic. False positives are acceptable: the user's own phone still reaches them.
// Single-name guard: a bare last name never matches alone — it needs a suffix or full name.
export const isSelfEmployed = (
  employerName: string,
  userFirstName: string,
  userLastName: string,
): boolean => {
  const employer = normalize(employerName ?? '');
  if (!employer) return false;

  const first = normalize(userFirstName ?? '');
  const last = normalize(userLastName ?? '');

  if (SELF_KEYWORDS.some((pattern) => pattern.test(employer))) return true;

  if (first && last) {
    const fullName = `${first} ${last}`;
    if (employer === fullName) return true;
    if (BUSINESS_SUFFIXES.some((suffix) => employer === `${fullName} ${suffix}`)) return true;
  }

  if (first && employer.startsWith(`${first}'s `)) return true;

  if (last && BUSINESS_SUFFIXES.some((suffix) => employer === `${last} ${suffix}`)) return true;

  return false;
};
